import { render } from "./SectionPaymentReleasing.vue?vue&type=template&id=7008b280&scoped=true"
import script from "./SectionPaymentReleasing.vue?vue&type=script&lang=js"
export * from "./SectionPaymentReleasing.vue?vue&type=script&lang=js"

import "./SectionPaymentReleasing.vue?vue&type=style&index=0&id=7008b280&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7008b280"]])

export default __exports__